import $ from 'jquery';

$(document).ready(() => {
    var stmenu_down_timer;
    function megaHoverOver(){
        $(this).addClass('current');
        if($(this).find('.stmenu_sub').children().size())
        {
            var stmenu_sub_dom = $(this).find(".stmenu_sub");
            stmenu_sub_dom.stop();
            stmenu_down_timer = setTimeout(function(){
                if(typeof(sttheme.submemus_animation) !== 'undefined' && sttheme.submemus_animation)
                    stmenu_sub_dom.slideDown('fast',function(){
                      stmenu_sub_dom.css('overflow','visible');
                    });
                else
                    stmenu_sub_dom.fadeIn('fast',function(){
                      stmenu_sub_dom.css('overflow','visible');
                    });
            },100);
        }
    }
    function megaHoverOut(){ 
        clearTimeout(stmenu_down_timer);
        $(this).removeClass('current');
        $(this).find(".stmenu_sub").stop().hide(); 
    }
    $(".ml_level_0").hoverIntent({sensitivity: 7, 
         interval: 0, 
         timeout: 0}).hoverIntent(megaHoverOver,megaHoverOut);

    if(('ontouchstart' in document.documentElement || window.navigator.msMaxTouchPoints))
    {
        $(".ma_level_0").click(function(e){
            var ml_level_0 = $(this).parent();
            if(ml_level_0.find('.stmenu_sub').children().size())
            {
                if(!ml_level_0.hasClass('ma_touched'))
                {
                    $(".ml_level_0").removeClass('ma_touched');
                    ml_level_0.addClass('ma_touched');
                    return false;
                }
                else
                    ml_level_0.removeClass('ma_touched');
            }
        });
        $('.stmenu_sub .has_children').click(function(e){
            if(!$(this).hasClass('item_touched'))
            {
                $(".stmenu_sub .menu_touched").removeClass('item_touched');
                $(this).addClass('item_touched');
                return false;
            }
            else
                $(this).removeClass('item_touched');
        });
    }
});



// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js


// WEBPACK FOOTER //
// ./js/stmegamenu.js